export async function getUserById(userRepository, id) {
    return await userRepository.getUserById(id)
}